import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { contentsKeys } from '@codes/box-contents';

import type { ContentView } from '@lemoncloud/eureka-contents-api';

export const useContentCache = () => {
    const queryClient = useQueryClient();

    const prependContentToCache = useCallback(
        (content: ContentView) => {
            queryClient.setQueryData(contentsKeys.list({ limit: -1, activity: 1 }), (oldData: any) => {
                if (!oldData) {
                    return { total: 1, data: [content] };
                }

                return {
                    ...oldData,
                    data: [content, ...oldData.data],
                    list: [content, ...oldData.list],
                    total: oldData.total + 1,
                };
            });
        },
        [queryClient]
    );

    const removeContentFromCache = useCallback(
        (contentId: string) => {
            queryClient.setQueryData(contentsKeys.list({ limit: -1, activity: 1 }), (oldData: any) => {
                if (!oldData) {
                    return oldData;
                }

                return {
                    ...oldData,
                    data: oldData.data.filter((origin: { id: string }) => origin.id !== contentId),
                    list: oldData.list.filter((origin: { id: string }) => origin.id !== contentId),
                    total: oldData.total - 1,
                };
            });
        },
        [queryClient]
    );

    return {
        prependContentToCache,
        removeContentFromCache,
    };
};
